import React, { useState, useEffect } from "react";


import "./basicInput/binput.css";

const KeywordsInput = (props) => {
  const [focused, setFocused] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const value = props.value || [];
  console.log(value.length); // الان همیشه safe هست

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      props.onChange([...value, inputValue.trim()]);
      setInputValue("");
    }
  };

  const removeKeyword = (index) => {
    const updated = value.filter((_, i) => i !== index);
    props.onChange(updated);
  };

  return (
    <div className={`m-${props.margin} ${props.className}`}>
      <label
        className={`labelpass ${focused || value ? "floating" : ""}`}
        style={{ "--bg": `${bg(props.bgcolor)}` }}
        aria-label={props.text}
      >
        <input
          className={`inputpass border-${props.bcolor} text-${props.textcolor}`}
          type="text"
          name={props.text}
          placeholder={props.text}
          required
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
          onKeyDown={handleKeyDown}
        />
      </label>
      <div className="keyword-container">
        {value.map((keyword, index) => (
          <span key={index} className="badge bg-secondary me-1">
            {keyword}
            <button
              type="button"
              className="btn-close btn-close-white ms-1"
              style={{ fontSize: "0.6rem" }}
              onClick={() => removeKeyword(index)}
            ></button>
          </span>
        ))}
      </div>
    </div>
  );
};

const bg = (color) => {
  switch (color) {
    case "dark":
      return "#212529";
    case "white":
      return "#ffffff";
    default:
      return "#ffffff";
  }
};

export default KeywordsInput;
